import React, { Component } from "react";

import mixpanel from "../../../lib/mixPanel";

import LocationSearchInput from "../../Common/Places";

export default class Submit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addManually: !!props.addressLine1,
      title: props.title,
      addressLine1: props.addressLine1,
      addressLine2: props.addressLine2,
      postalCode: props.postalCode,
      tips: props.tips,
      flatNumber: props.flatNumber,
      selectIcon: false,
      selectedIcon: "house"
    };
  }

  static getDerivedStateFromProps(props, state) {
    //postal code place api'den en son geliyor (!dikkat)
    if (props.postalCode !== state.postalCode) {
      return {
        ...props,
        addManually: true
      };
    }
    if (props.title !== state.title) {
      return {
        title: props.title
      };
    }
    if (props.flatNumber !== state.flatNumber) {
      return {
        flatNumber: props.flatNumber
      };
    }
    if (props.addressLine1 && props.addressLine1 !== state.addressLine1) {
      return {
        addressLine1: props.addressLine1,
        addManually: true
      };
    }
    if (props.addressLine2 !== state.addressLine2) {
      return {
        addressLine2: props.addressLine2
      };
    }
    if (props.tips !== state.tips) {
      return {
        tips: props.tips
      };
    }

    return null;
  }
  handleManuelSubmit = event => {
    event.preventDefault();
    const { addManually } = this.state;
    if (!addManually) {
      mixpanel.track("New Address Form", { _source: "Add manually" });
    }
    this.setState({ addManually: !addManually });
  };
  toggleIconDropdown = () => {
    const { selectIcon } = this.state;
    this.setState({
      selectIcon: !selectIcon
    });
  };
  selectedIcon = (icon, id) => {
    console.log(icon, id)
    if (id) {
      const { handleChangeIcon } = this.props;
      handleChangeIcon(id);
      this.setState(
        {
          selectedIcon: icon
        },
        () => this.toggleIconDropdown()
      );
    }
  };
  render() {
    const {
      handleSubmit,
      handleChange,
      handleSelectPlace,
      checkOut,
      formErrors,
      handleCloseSection,
      showErrors
    } = this.props;
    const {
      title,
      addressLine1,
      addressLine2,
      postalCode,
      tips,
      flatNumber,
      addManually,
      selectIcon,
      selectedIcon
    } = this.state;
    return (
      <div>
        <div className="modal-bg" />

        <div className="modal">
          {/* Header */}
          <div className="head-general with-back">
            <a
              href="javascript: void(0)"
              onClick={e => handleCloseSection(e, "newAddress")}
              className="back"
            >
              <img src="/png/chevron-left.png" />
            </a>
            <h4>
              {(checkOut && "Delivery Details") ||
                (addressLine1 || "New Address")}
            </h4>
            <a
              href="javascript: void(0)"
              className="close"
              onClick={e => handleCloseSection(e, "newAddress")}
            >
              <i className="icon icon-close" />
            </a>
          </div>
          {/* Header */}

          <div className="modal-body">
            {(addManually && (
              <React.Fragment>
                <div className="row center-sm">
                  <div className="col-sm-8">
                    <div className="add-address-form">
                      {(!checkOut && !title && (
                        <div className="add-address visible-xs">
                          <a
                            href="javascript: void(0)"
                            onClick={this.handleManuelSubmit}
                          >
                            <i className="icon icon-close icon-plus" /> Add
                            location...
                          </a>
                          <br />
                        </div>
                      )) || <noscript />}

                      <form onSubmit={handleSubmit}>
                        <div className="d-flex align-items-center">
                          <div className="svg-icon-list active visible-xs">
                            <div
                              onClick={this.toggleIconDropdown}
                              className="selected-item d-flex align-items-center justify-content-between"
                            >
                              <img
                                src={`/svg/address-svg/${selectedIcon}.svg`}
                              />
                              <i className="icon icon-arrow-3" />
                            </div>
                            {selectIcon && (
                              <div className="svg-icon-dropdown">
                                <div className="d-flex align-items-center justify-content-start">
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("house", 1)
                                    }
                                  >
                                    <img src="/svg/address-svg/house.svg" />
                                  </a>
                                  <a
                                    onClick={() => this.selectedIcon("sun", 2)}
                                  >
                                    <img src="/svg/address-svg/sun.svg" />
                                  </a>
                                  <a
                                    onClick={() => this.selectedIcon("bag", 3)}
                                  >
                                    <img src="/svg/address-svg/bag.svg" />
                                  </a>
                                  <a
                                    onClick={() => this.selectedIcon("love", 4)}
                                  >
                                    <img src="/svg/address-svg/love.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("locate", 5)
                                    }
                                  >
                                    <img src="/svg/address-svg/locate.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("pizza", 6)
                                    }
                                  >
                                    <img src="/svg/address-svg/pizza.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("pineapple", 7)
                                    }
                                  >
                                    <img src="/svg/address-svg/pineapple.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("doughnut", 8)
                                    }
                                  >
                                    <img src="/svg/address-svg/doughnut.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("lollipop", 9)
                                    }
                                  >
                                    <img src="/svg/address-svg/lollipop.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("soda-2", 10)
                                    }
                                  >
                                    <img src="/svg/address-svg/soda-2.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("pia-colada", 11)
                                    }
                                  >
                                    <img src="/svg/address-svg/pia-colada.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("parasol", 12)
                                    }
                                  >
                                    <img src="/svg/address-svg/parasol.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("smallprize", 13)
                                    }
                                  >
                                    <img src="/svg/address-svg/smallprize.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("juice", 14)
                                    }
                                  >
                                    <img src="/svg/address-svg/juice.svg" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.selectedIcon("watermelon", 15)
                                    }
                                  >
                                    <img src="/svg/address-svg/watermelon.svg" />
                                  </a>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="form-group sticky-form-label flex-grow-1">
                            <input
                              defaultValue={title}
                              className={`form-input ${(title && "active") ||
                                ""}`}
                              onChange={handleChange}
                              type="text"
                              id="title"
                            />
                            <label htmlFor="title">
                              *Name (Home, Work, Mom{"'"}s etc.)
                            </label>
                          </div>
                        </div>

                        <div
                          className={`form-group sticky-form-label ${(showErrors &&
                            formErrors["postalCode"] &&
                            "error") ||
                            ""}`}
                        >
                          <input
                              defaultValue={postalCode}
                            className={`form-input ${(postalCode && "active") ||
                              ""}`}
                            onChange={handleChange}
                            type="text"
                            id="postalCode"
                          />
                          <label htmlFor="postalCode">*Postcode</label>
                          <span>
                            {(showErrors &&
                              formErrors["postalCode"] &&
                              formErrors["postalCode"]) ||
                              ""}
                          </span>
                        </div>
                        <div
                          className={`form-group sticky-form-label ${(showErrors &&
                            formErrors["flatNumber"] &&
                            "error") ||
                            ""}`}
                        >
                          <input
                            defaultValue={flatNumber}
                            className={`form-input ${(flatNumber && "active") ||
                              ""}`}
                            onChange={handleChange}
                            type="text"
                            id="flatNumber"
                          />
                          <label htmlFor="flatNumber">
                            *Flat Number / Building Name
                          </label>
                          <span>
                            {(showErrors &&
                              formErrors["flatNumber"] &&
                              formErrors["flatNumber"]) ||
                              ""}
                          </span>
                        </div>
                        <div
                          className={`form-group sticky-form-label ${(showErrors &&
                            formErrors["addressLine1"] &&
                            "error") ||
                            ""}`}
                        >
                          <input
                            defaultValue={addressLine1}
                            className={`form-input ${(addressLine1 &&
                              "active") ||
                              ""}`}
                            onChange={handleChange}
                            type="text"
                            id="addressLine1"
                          />
                          <label htmlFor="addressLine1">*Address Line 1</label>
                          <span>
                            {(showErrors &&
                              formErrors["addressLine1"] &&
                              formErrors["addressLine1"]) ||
                              ""}
                          </span>
                        </div>
                        <div className="form-group sticky-form-label">
                          <input
                            defaultValue={addressLine2}
                            className={`form-input ${(addressLine2 &&
                              "active") ||
                              ""}`}
                            onChange={handleChange}
                            type="text"
                            id="addressLine2"
                          />
                          <label htmlFor="addressLine2">*Address Line 2</label>
                        </div>
                        <div className="form-group sticky-form-label">
                          <input
                            defaultValue={tips}
                            className={`form-input ${(tips && "active") || ""}`}
                            onChange={handleChange}
                            type="text"
                            id="tips"
                          />
                          <label htmlFor="tips">
                            *Delivery tips. E.g. Flat number if in apartment block
                          </label>
                        </div>
                        <div className="use-buttons">
                          <button
                            className={
                              (addressLine1 && postalCode && "btn btn-blue") ||
                              "btn btn-gray"
                            }
                            type="submit"
                          >
                            <span>Done</span>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )) || (
              <div>
                <div className="row center-sm">
                  <div className="col-sm-8">
                    <LocationSearchInput
                      onSubmit={handleSelectPlace}
                      placeholder="e.g. 39 Old Town"
                    />
                    <div className="add-address visible-xs">
                      <a
                        href="javascript: void(0)"
                        onClick={this.handleManuelSubmit}
                      >
                        <i className="icon icon-close icon-plus" /> Add
                        manually...
                      </a>
                    </div>
                  </div>{" "}
                  {/* .col-sm-8 */}
                </div>{" "}
                {/* .row */}
              </div>
            )}
          </div>
          {/* .modal-body */}
        </div>
        {/* .modal */}
      </div>
    );
  }
}
